import { FC } from 'react'
import { PersonalSpace } from '../../apps-list/PersonalSpace'
import { GroupsSpace } from '../../apps-list/GroupsSpace'
import { DirectMessagesItem } from '../DirectMessagesItem'
import { AdminSettingsItem } from '../AdminSettingsItem'
import { WlsyLogo } from '../WlsyLogo'
import { Profile } from '../Profile'
import { NotificationsItem } from '../NotificationsItem'
import { SearchItem } from '../SearchItem'
import { ServerInfoDropdown } from '../ServerInfoDropdown'
import { useSelector } from 'react-redux'
import { authSlice } from '@wellesley/auth'
import { cn } from '@wellesley/ui'

export const Toolbar: FC = () => {
  const isLoggedIn = useSelector(authSlice.selectors.selectIsAuthenticated)
  return (
    <div className="my-s ml-s flex h-[calc(100vh-32px)] flex-col items-stretch justify-between rounded-lg bg-white p-xs transition-all duration-300 ease-in-out">
      <div className="flex flex-1 flex-col">
        <WlsyLogo />
        <div className="flex w-full flex-col gap-xs">
          <PersonalSpace />
          <SearchItem />
          {isLoggedIn && (
            <>
              <NotificationsItem />
              <DirectMessagesItem />
              <AdminSettingsItem />
            </>
          )}
        </div>
        <div
          className={cn('flex w-full flex-col gap-xs', {
            'flex-1': isLoggedIn,
          })}
        >
          <GroupsSpace />
          {!isLoggedIn && <ServerInfoDropdown />}
        </div>
      </div>
      <Profile />
    </div>
  )
}
